import styled from "styled-components";

export const ContainerList = styled.div`
  margin: 15px auto 80px;
  width: 97%;
  box-shadow: 0px 0px 9px -5px rgba(66, 68, 90, 1);
  padding: 10px;
  border-radius: 10px;
`;

export const ButtonsSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  column-gap: 5px;
`;
